import React from "react";

import { Select } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import { workspaceLabel } from "@/utils/UWorkspaces";
import { cn } from "@/utils/cn";

import { TWorkspace } from "@/types";

/**
 * Which workspace a page about one workspace shows (/workspace,
 * /subscription). Nothing for a user with one to choose from - a solo
 * never sees workspaces.
 */
export const WorkspacePicker: React.FC<{
	options: TWorkspace[];
	value?: number;
	onChange: (workspaceId: number) => void;
	className?: string;
}> = ({ options, value, onChange, className }) => {
	if (options.length < 2) return null;

	return (
		<div className={cn(["w-full max-w-xs", className])}>
			<Select<number>
				label={t("workspace.switcher.label")}
				picto="briefcase"
				options={options.map((workspace) => ({
					value: workspace.id,
					label: workspaceLabel({
						...workspace,
						mine: workspace.role === "OWNER",
					}),
				}))}
				value={value ?? null}
				onChange={(next) => {
					if (typeof next === "number") onChange(next);
				}}
			/>
		</div>
	);
};
